import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { StarbaseDataServiceWithRequisites, UserAccountModel } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { SquarePaymentRequest } from '../models/paymentRequest';
import { UserSubscriptionModel_ext } from '../models/userSubscription';

@Injectable({
  providedIn: 'root'
})
export class FortisSubscriptionService extends StarbaseDataServiceWithRequisites<UserSubscriptionModel_ext> {

  public subscriptionUpdated = false;
  protected _staleDataTimeout = 0;
  protected _getOneUri: string;
  protected _getAllUri: string;
  protected _postUri: string;
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri: string;
  private _createSubscriptionUri = '/api/FortisSubscription/CreateFortisUserSubscription';
  private _newUserCreateSubscriptionUri = '/api/FortisSubscription/NewUserFortisSubscription';
  private _changeSubscriptionUri = '/api/FortisSubscription/ChangeFortisUserSubscription';
  private _cancelSubscriptionUri = '/api/FortisSubscription/CancelFortisUserSubscription';
  private _getCardUri = '/api/FortisSubscription/GetPaymentMethodOnFile?userId=';
  private _saveCardUri = '/api/FortisSubscription/UpdatePaymentMethod';
  private _newUserSaveCardUri = '/api/FortisSubscription/NewUserPaymentMethod';
  private _removeCardUri = '/api/FortisSubscription/RemovePaymentMethod';
  private _tranIntUri = '/api/FortisSubscription/GetClientToken';

  constructor(private _http: HttpClient, private _webAPISvc: WebApiService) {
    super(_http, _webAPISvc);
    this.defaultRetries = 0;
  }

  public get getCardUri() {
    return this._getCardUri;
  }

  public getClientToken(): Observable<string> {
    return this.getRequisiteData<string>(this._tranIntUri);
  }

  public createFortisSubscription(paymentInfo: SquarePaymentRequest, newUser = false): Observable<any> {
    const sendIt = JSON.parse(JSON.stringify(paymentInfo));
    sendIt.userAccount.userGroups = [];
    sendIt.userAccount.contact = null;
    sendIt.userAccount.subscriptionRecord = null;
    sendIt.subscriptionPrice.subscriptionUserGroup = null;
    return this.postRequisiteData(newUser ?
      this._newUserCreateSubscriptionUri
      : this._createSubscriptionUri, sendIt).pipe(tap(() => this.subscriptionUpdated = true));
  }
  public cancelFortisSubscription(subUser: UserAccountModel): Observable<any> {
    const sendIt = JSON.parse(JSON.stringify(subUser));
    sendIt.userGroups = [];
    sendIt.contact = null;
    sendIt.subscriptionRecord = null;
    // need to check server-side if subscription is already canceled.
    return this.postRequisiteData(this._cancelSubscriptionUri, sendIt).pipe(
      tap(() =>
        this.subscriptionUpdated = true));
  }

  public changeFortisSubscription(paymentInfo: SquarePaymentRequest): Observable<UserSubscriptionModel_ext> {
    const sendIt = JSON.parse(JSON.stringify(paymentInfo));
    sendIt.userAccount.userGroups = [];
    sendIt.userAccount.contact = null;
    sendIt.userAccount.subscriptionRecord = null;
    sendIt.subscriptionPrice.subscriptionUserGroup = null;
    return this.putRequisiteData(this._changeSubscriptionUri, '', sendIt).pipe(
      tap(() => this.subscriptionUpdated = true));
  }

  public saveFortisCard(userId: number, vaultId: string, newUser = false): Observable<any> {
    if (newUser) {
      return this.postRequisiteData(`${this._newUserSaveCardUri}?userId=${userId}&tokenId=${vaultId}`, null);
    }
    return this.putRequisiteData(`${this._saveCardUri}?userId=${userId}&tokenId=${vaultId}`, '', null);
  }

  public removeFortisCard(userId: number): Observable<any> {
    return this.deleteData(this._removeCardUri + '?userId=' + userId, '');
  }
}
